var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import InfoPopUp from '@web/components/layout/InfoPopUp';
import { useId } from 'react';
export var InformationCircle = function (_a) {
    var text = _a.text;
    var tooltipId = useId().replace(/:/g, '');
    return (_jsx(InfoPopUp, __assign({ text: text, classes: "w-5 h-5 ml-2 my-auto", tooltipClasses: "max-w-[350px] z-50", id: "info-pop-up-".concat(tooltipId), place: "right-start" }, { children: _jsx(InformationCircleIcon, {}) })));
};
